import axios from "axios";
import app_config from "app_config";
import store from "lib/store";
import { Template } from "@pdfme/common";


const APIURL = app_config.APIURLV2Base + "admin/report";

export interface ReportRecord {
  S: string;
  templateId: string;
  did: string;
  id1: string;
  id2: string;
}

export interface AReportAPIGetResponse extends ReportRecord {
  templateFile: Template;
  inputs: Record<string, unknown>[];
}

/**
 * Admin Report API
 */
export class AReportAPI {
  static async list(templateId: string, did_s: string, did_e: string, id1: string, id2: string,  signal?: AbortSignal): Promise<Array<ReportRecord>> {
    const res = await axios.get<Array<ReportRecord>>(
      APIURL + "/" + templateId,
      {
        params: {
          did_s,
          did_e,
          id1,
          id2
        },
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    return res.data;
  }


  static async get(id: string, signal?: AbortSignal): Promise<AReportAPIGetResponse> {
    const res = await axios.get(
      APIURL + "/get/" + id,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    // download report template file from s3
    const resfile = await axios.get(res.data.downloadInfo.url, {
      signal: signal,
    });

    return {...res.data, templateFile: resfile.data};
  }


  static async add(reportId: string, data: object, signal?: AbortSignal) {
    // update report template information
    const res = await axios.post(
      APIURL + "/add/" + reportId,
      data,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    return {
      S: res.data.S
    };
  }



  static async update(reportId: string, data: object, signal?: AbortSignal) {
    // update report template information
    const res = await axios.post(
      APIURL + "/update/" + reportId,
      data,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    return {
      S: res.data.S
    };
  }
}
